import { StyleRules } from "@mui/styles";

export const defaultStyle = {
    root: {
        width: '584px',
        padding: '56px',
        height: '400px',
        margin: 'auto',
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        top: 'calc(50% - 181px)',
        left: 'calc(50% - 292px)',

        borderRadius: '10px',
        border: '2px solid #009ADE',
    },

    header: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    body: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        padding: '20px 0',
    },
    footer: {
        display: 'flex',
        justifyContent: 'center',
    },
} as StyleRules